import { useEffect, useRef } from 'react'

const EXCLUDE_ATTRIBUTE = '[data-click-outside-exclude]'

export const useClickOutside = <T extends HTMLElement>(callback?: () => void, skipDialogs: boolean = false) => {
    const ref = useRef<T>(null)
    const callbackRef = useRef<() => void>()

    useEffect(() => {
        callbackRef.current = callback
    }, [callback])

    const handle = (e: PointerEvent) => {
        const target = e.target as Element | null
        const node = ref.current
        if (!node || !target || !target.closest) return

        if (node.contains(target)) return

        if (skipDialogs && target.closest('dialog')) return

        const excluded = target.closest(EXCLUDE_ATTRIBUTE)
        if (excluded && node.contains(excluded)) return

        callbackRef.current?.()
    }

    useEffect(() => {
        document.addEventListener('pointerdown', handle, true)
        return () => {
            document.removeEventListener('pointerdown', handle, true)
        }
    }, [])

    return ref
}
